export function isNumber(input) {
  if (typeof input === "number") {
    return true;
  } else if (typeof input === "string") {
    return Number.isInteger(Number(input));
  }
  return false;
}

export function isString(input) {
  return typeof input === "string" && input.trim() !== "";
}

export function isAlphabetical(input) {
  return /^[A-Za-z]*$/.test(input);
}

export function isStringOrArray(input) {
  return (
    (typeof input === "string" && input.trim() !== "") ||
    (Array.isArray(input) && input.length > 0)
  );
}

export function titleCase(str) {
  if (str && typeof str === "string" && str.length > 0) {
    if (str.includes("RWAs")) {
      return str;
    }
    if (str.includes("IT PARKS")) {
      return "IT Parks";
    }
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
}

export const na = /^(n\/a|N\/A|na|NA)$/;

export const isPanNumberValid = (panNumber) => {
  const panRegex = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;
  return panRegex.test(panNumber) || na.test(panNumber);
};

export const isGSTNumberValid = (gstNumber) => {
  const gstRegex =
    /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/;
  return gstRegex.test(gstNumber) || na.test(gstNumber);
};

export const isMobileNumberValid = (mobileNumber) => {
  const mobileRegex = /^[6789]\d{9}$/;
  return mobileRegex.test(mobileNumber);
};

export const isEmailValid = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isCompanyEmailValid = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) || na.test(email);
};

export const isNameValid = (name) => {
  const firstNameRegex = /^[A-Za-z]{1,25}$/;
  return firstNameRegex.test(name);
};

export function isNumberOrFloat(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

export function isValidIndianPhoneNumber(number) {
  // Regular expression for a valid Indian telephone or mobile number
  const regex = /^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?((?:[2-9]\d{1,3}\s*[-]\s*\d{6,10})|(?:[6789]\d{9}))$/;

  // Test the number against the regular expression
  return regex.test(number);
}
